<template>
<div class='widget-W0143V0001'>
  <div class="aula-sso-container">
    <button class="aula-sso-btn" :disabled="loading" @click="startSso">
      <span class="aula-sso-logo-wrapper">
        <svg width="28" height="32" viewBox="0 0 96 110" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M64.25 109.95H8.88C7.78 109.95 6.88 109.05 6.88 107.95C6.88 106.85 7.78 105.95 8.88 105.95H64.25C79.22 105.95 91.39 93.77 91.39 78.81V23.44C91.39 22.34 92.29 21.44 93.39 21.44C94.49 21.44 95.39 22.34 95.39 23.44V78.81C95.39 95.98 81.42 109.95 64.25 109.95ZM4.75 86.71V31.34C4.75 16.37 16.93 4.2 31.89 4.2H87.26C88.36 4.2 89.26 3.3 89.26 2.2C89.26 1.1 88.36 0.199997 87.26 0.199997H31.89C14.72 0.199997 0.75 14.17 0.75 31.34V86.71C0.75 87.81 1.65 88.71 2.75 88.71C3.85 88.71 4.75 87.81 4.75 86.71ZM35.86 45.65H45.37V71.1H51.23V45.65H60.74V40.25H35.86V45.65Z"
            fill="#baf7d0" />
        </svg>
      </span>
      <span class="aula-sso-btn-text">Gå til Teacherspace</span>
    </button>

    <form ref="ssoForm" :action="targetUrl" :method="formMethod" target="_blank">
      <input v-if="formMethod==='POST'" type="hidden" name="AulaToken" :value="aulaToken" />
      <input v-if="formMethod==='POST'" type="hidden" name="userProfile" :value="userProfile" />
    </form>
  </div>
</div>
</template>

<script>
export default {
  props: {
    getAulaToken: Function,
    triggerStepUp: Function,
    assuranceLevel: Number,
    isMobileApp: Boolean,
    userProfile: String
  },

  data: function () {
    return {
      aulaToken: null,
      loading: true,
      targetUrl: 'https://app.teacherspace.org/auth/aula_sso/callback',
      formMethod: 'POST'
    };
  },

  methods: {
    async startSso() {
      if (this.loading) return;
      this.loading = true;

      if (this.assuranceLevel < 3) {
        this.triggerStepUp();
        this.loading = false;
        return;
      }

      if (!this.aulaToken) {
        console.error('AulaToken not available');
        this.loading = false;
        return;
      }

      /* Build GET fallback for iOS/Android web-views */
      if (this.isMobileApp) {
        this.formMethod = 'GET';
        this.targetUrl +=
          `?AulaToken=${encodeURIComponent(this.aulaToken)}` +
          `&userProfile=${encodeURIComponent(this.userProfile || '')}`;
      }

      /* Submit and reset */
      this.$nextTick(() => {
        this.$refs.ssoForm.submit();
        this.loading = false;
      });
    },
  },

  mounted() {
    this.aulaToken = this.getAulaToken();
  },

  watch: {
    aulaToken: function () {
      if (this.aulaToken != undefined) {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.widget-W0143V0001 {
.aula-sso-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.aula-sso-loading {
  font-size: 1rem;
  color: #2091A2;
  margin-bottom: 0.5rem;
}

.aula-sso-btn {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: #2091A2;
  color: #fff;
  padding: 0.85rem 2.25rem;
  border: none;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(20, 83, 45, 0.08);
  font-size: 1.25rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  outline: none;
}

.aula-sso-btn:hover:not([disabled]) {
  background: #45B7C1;
}

.aula-sso-btn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
  background: #2091A2;
}

.aula-sso-logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 28px;
}

.aula-sso-btn-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 1.2;
}
}
</style>
